<template>
  <field-layout :content="content">
    <selector-input :options="eventTypeOptions" :initial-value="value" :validation-errors="validationErrors"
                    field="eventTypeId" @changed="updateFieldValue" />
  </field-layout>
</template>

<script>
import FieldLayout from '@/campaign-form-shared/field-layout'
import FieldMixin from '@/campaign-form-shared/field-mixin'
import { mapState } from 'vuex'
import SelectorInput from '@/components/inputs/selector-input'

export default {
  components: { FieldLayout, SelectorInput },

  mixins: [ FieldMixin ],

  computed: {
    ...mapState(['eventTypeOptions'])
  }
}
</script>

<style lang="scss" scoped>
@use "~common_styles/breakpoints" as breakpoints;

::v-deep(select) {
  height: 58px;

  @include breakpoints.screen-mobile-only {
    height: 50px;
  }

}
</style>
